/**
 * Created by Mark on 04/05/2017.
 */



import React   from 'react';
import Layout  from '../components/layouts/standard-page.js';
import Profile from '../components/profile/profile.js';
import About   from '../components/profile/profile-tabs/assignment/about-panel.js';
import Vocabulary from '../components/profile/profile-tabs/assignment/vocabulary-panel.js';
import Scores from '../components/profile/profile-tabs/assignment/scores-panel.js';
import {Button , OverlayTrigger , Tooltip} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import AssignmentServices from '../services/assignment-services.js';
import AssignmentStore from '../store/assignment-store.js';
import { Link , hashHistory} from 'react-router'
export default class AssignmentOverview extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {assignment:false }
    }

    componentDidMount() {
        AssignmentServices.getAssignment(this.props.params.assignmentID)
    }

    componentWillMount(){
        AssignmentStore.on("GET_HOMEWORK_DETAIL" , () => {
            this.setState({assignment:AssignmentStore.getHomework(this.props.params.assignmentID)});
        });
    }

    deleteHomework(){
        AssignmentServices.deleteHomework(this.props.params.assignmentID).then(function(){
            hashHistory.push('/assignment/managment');
        }.bind(this))
    }

    classSidePanel(){

        if(!this.state.assignment) return;

        return<div>
                <div className="pmo-pic">
                    <div className="p-t-20 pmo-stat palette-Branding secondary bg">
                        <h4 className="m-0 c-white">{this.state.assignment.name}</h4>
                    </div>
                </div>
                <div className="pmo-block pmo-contact hidden-xs p-t-0 p-b-10">
                    <ul>
                        <li>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-776' } defaultMessage={ 'Jump to resources' }/></Tooltip>}>
                                    <i className="zmdi zmdi-face"></i>
                            </OverlayTrigger>
                            {this.state.assignment.totalStudents}
                        </li>
                        <li>
                               <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-483' } defaultMessage={ 'Jump to resources' }/></Tooltip>}>
                                   <i className="zmdi zmdi-calendar-alt"></i>
                               </OverlayTrigger>
                               {this.state.assignment.setDTS}
                        </li>
                        <li>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip"><FormattedMessage id={ 'ui-853' } defaultMessage={ 'Jump to resources' }/></Tooltip>}>
                                <i className="zmdi zmdi-calendar"></i>
                            </OverlayTrigger>
                            {this.state.assignment.dueDTS}
                        </li>
                    </ul>
                </div>
                <div className="pmo-block p-t-0 p-b-20">
                    <Link to={'/assignment/edit/'+this.props.params.assignmentID}><Button className="btn-block btn-primary"><FormattedMessage id={ 'ui-663' } defaultMessage={ 'Edit' }/></Button></Link>
                    <Link to={'/assignment/duplicate/'+this.props.params.assignmentID}><Button className="btn-block btn-primary"><FormattedMessage id={ 'ui-2016' } defaultMessage={ 'Duplicate' }/></Button></Link>
                    <Button onClick={this.deleteHomework.bind(this)}className="btn-block btn-primary"><FormattedMessage id={ 'ui-665' } defaultMessage={ 'delete' }/></Button>
                </div>
            </div>
    }

    render(){
        return (<Layout>
                    <Profile data={{assignmentID:this.props.params.assignmentID , assignment:this.state.assignment}} sidePanel={this.classSidePanel.bind(this)}  panels={[About , Vocabulary , Scores]} />
                </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/assignment-overview.js